import { request } from '@/services/apiClient';
import type { CreateTenantInput, Tenant, UpdateTenantInput } from '../types';

/** Tenant directory calls (platform_admin only). Components never call axios. */
export const tenantApi = {
	/** Every tenant (plain array, no pagination). */
	list(signal?: AbortSignal): Promise<Tenant[]> {
		return request<Tenant[]>({ url: '/v1/tenants', method: 'GET', signal });
	},

	/** `409 TENANT_SLUG_ALREADY_EXISTS` when the slug is taken. */
	create(input: CreateTenantInput): Promise<Tenant> {
		return request<Tenant>({ url: '/v1/tenants', method: 'POST', data: input });
	},

	/** Rename or suspend/reactivate. The default tenant cannot be suspended. */
	update(id: string, input: UpdateTenantInput): Promise<Tenant> {
		return request<Tenant>({
			url: `/v1/tenants/${encodeURIComponent(id)}`,
			method: 'PATCH',
			data: input,
		});
	},
};
